import { render, staticRenderFns } from "./ChapterAmbassadorStepTwo.vue?vue&type=template&id=273a40bd"
import script from "./ChapterAmbassadorStepTwo.vue?vue&type=script&lang=js"
export * from "./ChapterAmbassadorStepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports